import './assets/js/vendor'
import './polyfills'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.min.css'
import './assets/css/icons.min.css'
import 'animate.css/animate.min.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';

// Plugins
import EditorsPlugin from './editors/index';
import BootstrapVue from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
import translations from './i18n/messages'
import dateTimeFormats from './i18n/dateTimeFormats'
import { VueMasonryPlugin } from 'vue-masonry';
import './plugins/table.plugin';
import ValidationPlugin from './plugins/validation.plugin'
import './plugins/sweetalert.plugin';
import MapsPlugin from './plugins/maps.plugin';
import axios from 'axios'

import CustomComponents from '@/components/index'
import {Bar} from 'vue-chartjs'
Vue.component('bar-chart', Bar);

axios.interceptors.response.use(r => r, err => {
  console.error("Received error", err);
  return err.response;
});

Vue.use(EditorsPlugin);
Vue.use(BootstrapVue);
Vue.use(VueI18n);
Vue.use(VueMasonryPlugin);
Vue.use(ValidationPlugin);
Vue.use(CustomComponents);
Vue.use(MapsPlugin);

import './filters/date.filter'
import './filters/numbers.filter'
import './directives/toUpperCase'

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n: new VueI18n({
    locale: 'rs',
    messages: translations,
    dateTimeFormats
  }),
  render: h => h(App)
}).$mount('#app')
